export default __webpack_public_path__ + "static/6-80f3653187c2bc088e1f66647c05b1e2.jpg";